<template>
  <div class="container welfare-page">
    <div class="welfare-tabs">
      <button v-if="pointsEntryVisible" type="button" :class="{ active: section === 'points' }" @click="navigate('/member/points')">积分中心</button>
      <button type="button" :class="{ active: section === 'vip' }" @click="navigate('/member/vip')">晋级彩金</button>
      <button type="button" :class="{ active: section === 'gift' }" @click="navigate('/member/gift')">晋级豪礼</button>
    </div>

    <div v-if="!isLoggedIn" class="welfare-state">
      <b>请先登录</b>
      <button type="button" @click="openAuth('login')">登录后查看</button>
    </div>
    <div v-else-if="loading" class="welfare-state">正在加载…</div>
    <div v-else-if="error && !pointsCenter && !vipDetail && !giftRule" class="welfare-state error">
      <b>加载失败</b>
      <ErrorNotice :message="error"></ErrorNotice>
      <button type="button" @click="loadSection">重新获取</button>
    </div>

    <template v-else-if="section === 'points' && pointsCenter">
      <section class="welfare-hero">
        <img v-if="pointsCenter.iconUrl" :src="pointsCenter.iconUrl" alt="" />
        <div>
          <small>{{ pointsCenter.pointsName || '积分' }}</small>
          <strong>{{ pointsCenter.memberBalance }}</strong>
          <p>当前{{ pointsCenter.pointsName || '积分' }}余额</p>
        </div>
      </section>
      <section v-if="pointsCenter.status !== 1" class="welfare-card">{{ pointsCenter.pauseMessage || '积分中心暂未开放' }}</section>
      <section v-else-if="pointsCenter.memberPointsStatus === 2" class="welfare-card">{{ pointsCenter.memberFreezePrompt || '您的积分账户已冻结' }}</section>
      <template v-else>
        <section class="welfare-card">
          <h2>积分任务</h2>
          <p v-if="!pointsCenter.tasks.length">暂无进行中的积分任务</p>
          <article v-for="task in pointsCenter.tasks" :key="task.id" class="welfare-task">
            <img v-if="task.iconUrl" :src="task.iconUrl" alt="" />
            <div>
              <b>{{ task.title }} <i>{{ task.taskTypeName }}</i></b>
              <span>{{ task.subtitle }}</span>
              <small>{{ task.releaseRule }}</small>
              <small v-if="task.description">{{ task.description }}</small>
            </div>
          </article>
        </section>
        <section class="welfare-card">
          <h2>待领取积分</h2>
          <p v-if="!rewards.length">暂无待领取积分</p>
          <article v-for="reward in rewards" :key="reward.transactionNo" class="welfare-reward">
            <div>
              <b>{{ reward.points }} {{ pointsCenter.pointsName || '积分' }}</b>
              <small>{{ reward.remark || '任务奖励' }}</small>
              <small>流水号：{{ reward.transactionNo }}</small>
            </div>
            <button type="button" class="primary" :disabled="Boolean(claimingNo)" @click="claimReward(reward)">
              {{ claimingNo === reward.transactionNo ? '领取中' : '领取' }}
            </button>
          </article>
          <button v-if="rewards.length < rewardTotal" type="button" class="welfare-more" :disabled="loadingMore || Boolean(claimingNo)" @click="loadMoreRewards">
            {{ loadingMore ? '加载中…' : '加载更多' }}
          </button>
          <ErrorNotice v-if="error" class="welfare-error" :message="error"></ErrorNotice>
        </section>
        <section v-if="pointsRules" class="welfare-card">
          <h2>积分规则</h2>
          <div class="help-rich-text" v-html="pointsRules"></div>
        </section>
      </template>
    </template>

    <template v-else-if="section === 'vip' && vipDetail">
      <section class="welfare-hero">
        <div>
          <small>{{ vipDetail.levelName || 'VIP' }}</small>
          <strong>晋级进度 {{ vipDetail.progressRate || '0' }}%</strong>
          <p>存款 {{ vipDetail.currentDeposit || '0.00' }} · 流水 {{ vipDetail.currentTurnover || '0.00' }}</p>
        </div>
      </section>
      <section class="welfare-card promotion-panel" aria-label="晋级彩金配置">
        <header class="promotion-heading">
          <div>
            <h2>{{ selectedRule?.activityTitle || '晋级彩金' }}</h2>
            <p>选择等级，查看对应优惠与参与条件</p>
          </div>
          <button class="promotion-refresh" type="button" :disabled="submitting" @click="loadSection">刷新配置</button>
        </header>
        <div v-if="promotionRules.length" class="welfare-levels promotion-levels" role="group" aria-label="选择等级">
          <button
            v-for="rule in promotionRules"
            :key="rule.memberLevelId"
            type="button"
            :aria-pressed="rule.memberLevelId === selectedLevelId"
            :class="{ active: rule.memberLevelId === selectedLevelId }"
            :disabled="submitting"
            @click="selectPromotionLevel(rule.memberLevelId)"
          >
            {{ (vipDetail.levels || []).find(item => item.levelId === rule.memberLevelId)?.levelName || `等级${rule.memberLevelId}` }}
          </button>
        </div>
        <p v-else class="promotion-empty" role="status">暂无晋级彩金规则</p>
        <div v-if="selectedRule" class="vip-promotion-layout">
          <div class="promotion-details">
            <div class="promotion-rule-heading">
              <h3>{{ selectedLevel?.levelName || '所选等级' }} 优惠规则</h3>
              <span v-if="selectedLevelId === vipDetail.levelId" class="promotion-level-note">当前等级</span>
              <span v-else-if="Number(selectedLevel?.rankNo || 0) > currentRank" class="promotion-level-note">尚未达到</span>
            </div>
            <dl class="welfare-metrics promotion-metrics">
              <div v-for="item in promotionMetrics" :key="item.label">
                <dt>{{ item.label }}</dt>
                <dd>{{ item.value }}</dd>
              </div>
            </dl>
            <div v-if="selectedRule.participatingVenues?.length" class="promotion-venues">
              <span>参与场馆</span>
              <ul><li v-for="venue in selectedRule.participatingVenues" :key="venue.venueId">{{ venue.venueName }}</li></ul>
            </div>
          </div>
          <form class="welfare-form promotion-application" @submit.prevent="claimVipPromotion">
            <h3>参与活动</h3>
            <p v-if="selectedRule.enabled !== 1" class="promotion-notice" role="status">{{ selectedRule.unavailableReason || '晋级彩金活动暂未开放' }}</p>
            <label>选择场馆
              <select v-model.number="selectedVenueId" :disabled="selectedRule.enabled !== 1 || submitting" required>
                <option :value="0" disabled>请选择场馆</option>
                <option v-for="venue in selectedRule.participatingVenues" :key="venue.venueId" :value="venue.venueId">{{ venue.venueName }}</option>
              </select>
            </label>
            <label>转入金额（元）
              <input :disabled="selectedRule.enabled !== 1 || submitting" data-decimal-input="2" v-model="transferAmount" inputmode="decimal" :placeholder="`最低${selectedRule.minimumTransferAmount || '0'}`" />
            </label>
            <button class="primary" type="submit" :disabled="!canClaimPromotion">{{ claimButtonText }}</button>
            <ErrorNotice v-if="error" :message="error" />
          </form>
        </div>
      </section>
      <VipBonusHistory :refresh-key="bonusRefreshKey" />
      <section class="welfare-card" aria-label="VIP活动规则">
        <h2>活动规则</h2>
        <ErrorNotice v-if="vipActivityRulesError" class="welfare-error" :message="vipActivityRulesError"></ErrorNotice>
        <p v-else-if="!vipActivityRules.length">暂无VIP活动规则</p>
        <div v-else class="help-rich-text">
          <div v-for="(rule, index) in vipActivityRules" :key="`${rule.sortNo}-${index}`" v-html="sanitizeHelpContent(rule.content)"></div>
        </div>
      </section>
    </template>

    <template v-else-if="section === 'gift' && giftRule">
      <section class="welfare-hero">
        <img v-if="giftRule.rewardImageUrl" :src="giftRule.rewardImageUrl" alt="" />
        <div>
          <small>{{ giftRule.memberLevelName || '晋级豪礼' }}</small>
          <strong>{{ giftRule.rewardNames?.join(' + ') || '晋级豪礼' }}</strong>
          <p v-if="giftRule.applied === 1">{{ giftStatusText[giftRule.applicationStatus] || '已申请' }}</p>
          <p v-else-if="giftRule.enabled !== 1">活动未开放</p>
          <p v-else-if="giftRule.eligible !== 1">当前暂不可申请</p>
          <p v-else>提交后由后台审核、发货并完成入账</p>
        </div>
      </section>
      <section v-if="giftRule.applied === 1" class="welfare-card">
        <h2>申请进度</h2>
        <p>状态：{{ giftStatusText[giftRule.applicationStatus] || giftRule.applicationStatus || '已申请' }}</p>
        <p v-if="giftRule.logisticsCompany || giftRule.trackingNo">物流：{{ giftRule.logisticsCompany || '物流公司待更新' }} {{ giftRule.trackingNo }}</p>
      </section>
      <form v-else-if="giftRule.enabled === 1 && giftRule.eligible === 1" class="welfare-card welfare-form" @submit.prevent="applyGift">
        <h2>收货信息</h2>
        <label>收货人
          <input v-model.trim="receipt.receiverName" maxlength="100" placeholder="请输入收货人姓名" />
        </label>
        <label>手机号
          <input v-model.trim="receipt.phone" maxlength="30" placeholder="请输入收货人手机号" />
        </label>
        <label>收货地址
          <textarea v-model.trim="receipt.address" maxlength="500" rows="3" placeholder="请输入详细收货地址"></textarea>
        </label>
        <button class="primary" type="submit" :disabled="!canApplyGift">{{ giftButtonText }}</button>
        <ErrorNotice v-if="error" class="welfare-error" :message="error"></ErrorNotice>
      </form>
    </template>
  </div>
</template>

<script setup>
import { reportError } from '../../services/feedback.js'

import ErrorNotice from '../feedback/ErrorNotice.vue'
import { isDecimalAmount } from '../../utils/decimalInput.mjs'
import { computed, ref, watch } from 'vue'
import { useAppContext } from '../../composables/appContext'
import { webApi } from '../../services/webApi'
import { readVipActivityRules } from '../../services/vipActivityRules'
import VipBonusHistory from './VipBonusHistory.vue'

const { currentPath, isLoggedIn, navigate, notify, openAuth, sanitizeHelpContent, pointsEntryVisible, loadPointsEntry } = useAppContext()
let loadRequestId = 0

const section = computed(() => {
  if (currentPath.value === '/member/points') return 'points'
  if (currentPath.value === '/member/vip') return 'vip'
  if (currentPath.value === '/member/gift') return 'gift'
  return ''
})

const loading = ref(false)
const error = ref('')
const submitting = ref(false)

const pointsCenter = ref(null)
const rewards = ref([])
const rewardTotal = ref(0)
const rewardPage = ref(1)
const loadingMore = ref(false)
const claimingNo = ref('')

const vipDetail = ref(null)
const promotionRules = ref([])
const selectedLevelId = ref(0)
const selectedVenueId = ref(0)
const transferAmount = ref('')
const bonusRefreshKey = ref(0)

const giftRule = ref(null)
const receipt = ref({ receiverName: '', phone: '', address: '' })

const cycleText = { 1: '仅1次', 2: '每日1次', 3: '每周1次', 4: '每月1次' }
const giftStatusText = { PENDING: '待发货', SHIPPED: '已发货', COMPLETED: '已完成' }

const vipActivityRulesState = computed(() => {
  try { return { rows: readVipActivityRules(vipDetail.value?.rules), error: '' } }
  catch (ruleError) { return { rows: [], error: ruleError.message || 'VIP活动规则读取失败' } }
})
const vipActivityRules = computed(() => vipActivityRulesState.value.rows)
const vipActivityRulesError = computed(() => vipActivityRulesState.value.error)
const pointsRules = computed(() => sanitizeHelpContent(pointsCenter.value?.rules || ''))
const currentRank = computed(() => {
  const level = (vipDetail.value?.levels || []).find(item => item.levelId === vipDetail.value?.levelId)
  return Number(level?.rankNo || 0)
})
const selectedLevel = computed(() => (vipDetail.value?.levels || []).find(item => item.levelId === selectedLevelId.value))
const selectedRule = computed(() => promotionRules.value.find(item => item.memberLevelId === selectedLevelId.value))
const selectedVenue = computed(() => (selectedRule.value?.participatingVenues || []).find(item => item.venueId === selectedVenueId.value))
const promotionMetrics = computed(() => {
  const rule = selectedRule.value
  return [
    { label: '最低转账', value: rule?.minimumTransferAmount || '--' },
    { label: '红利比例', value: rule ? `${rule.bonusRatio}%` : '--' },
    { label: '最高奖金', value: rule?.bonusCap || '--' },
    { label: '流水倍数', value: rule ? `${rule.turnoverMultiplier}倍` : '--' },
    { label: '次数限制', value: cycleText[rule?.applicationCycle] || '--' },
    { label: '游戏场馆', value: rule?.participatingVenues?.length ? `${rule.participatingVenues.length}个场馆` : '--' },
  ]
})
const canClaimPromotion = computed(() => {
  const rule = selectedRule.value
  const rank = Number(selectedLevel.value?.rankNo || 0)
  return Boolean(
    rule?.enabled === 1
    && rank <= currentRank.value
    && rule.claimed !== 1
    && selectedVenue.value
    && isDecimalAmount(transferAmount.value)
    && Number(transferAmount.value) > 0
    && Number(transferAmount.value) >= Number(rule.minimumTransferAmount || 0)
    && !submitting.value,
  )
})
const claimButtonText = computed(() => {
  const rank = Number(selectedLevel.value?.rankNo || 0)
  if (rank > currentRank.value) return '等级不符'
  if (selectedRule.value?.claimed === 1) return '已领取'
  if (selectedRule.value?.enabled !== 1) return selectedRule.value?.unavailableReason || '未开放'
  return submitting.value ? '申请中' : '立即领取'
})
const giftButtonText = computed(() => {
  const rule = giftRule.value
  if (!rule) return '立即申请'
  if (rule.applied === 1) return giftStatusText[rule.applicationStatus] || '已申请'
  if (rule.enabled !== 1) return '未开放'
  if (rule.eligible !== 1) return '暂不可申请'
  return submitting.value ? '提交中' : '提交申请'
})
const canApplyGift = computed(() => {
  const rule = giftRule.value
  return Boolean(
    rule?.enabled === 1
    && rule.eligible === 1
    && rule.applied !== 1
    && rule.memberLevelId
    && receipt.value.receiverName.trim()
    && /^1\d{10}$/.test(receipt.value.phone.trim())
    && receipt.value.address.trim()
    && !submitting.value,
  )
})

function resetWelfare() {
  error.value = ''
  pointsCenter.value = null
  rewards.value = []
  rewardTotal.value = 0
  rewardPage.value = 1
  vipDetail.value = null
  promotionRules.value = []
  selectedLevelId.value = 0
  selectedVenueId.value = 0
  transferAmount.value = ''
  giftRule.value = null
  receipt.value = { receiverName: '', phone: '', address: '' }
}

async function loadPoints() {
  const [center, pending] = await Promise.all([
    loadPointsEntry(),
    webApi.pointsRewards({ pageNumber: 1, pageSize: 10 }),
  ])
  if (!center || !Array.isArray(center.tasks)) throw new Error('积分中心数据异常')
  if (!pending || !Array.isArray(pending.data)) throw new Error('待领取积分数据异常')
  pointsCenter.value = center
  rewards.value = pending.data
  rewardTotal.value = Number(pending.total || 0)
  rewardPage.value = 1
}

async function loadMoreRewards() {
  if (loadingMore.value || claimingNo.value) return
  loadingMore.value = true
  error.value = ''
  try {
    const result = await webApi.pointsRewards({ pageNumber: rewardPage.value + 1, pageSize: 10 })
    if (!result || !Array.isArray(result.data)) throw new Error('待领取积分数据异常')
    rewards.value = [...rewards.value, ...result.data]
    rewardPage.value += 1
    rewardTotal.value = Number(result.total || 0)
  } catch (loadError) {
    error.value = loadError.message || '加载失败，请重试'
  } finally {
    loadingMore.value = false
  }
}

async function claimReward(reward) {
  if (claimingNo.value || loadingMore.value) return
  claimingNo.value = reward.transactionNo
  error.value = ''
  try {
    await webApi.claimPoints({ transactionNo: reward.transactionNo })
    notify('领取成功')
    try {
      await loadPoints()
    } catch {
      pointsCenter.value = null
      rewards.value = []
      rewardTotal.value = 0
      error.value = reportError('领取成功，积分数据刷新失败，请重新加载')
    }
  } catch (claimError) {
    error.value = claimError.message || '领取失败，请重试'
  } finally {
    claimingNo.value = ''
  }
}

async function loadVip() {
  const [detail, rules] = await Promise.all([
    webApi.vipDetail(),
    webApi.vipPromotionRules(),
  ])
  vipDetail.value = detail
  promotionRules.value = Array.isArray(rules?.data) ? rules.data : []
  const current = (detail?.levels || []).find(item => item.levelId === detail?.levelId)
  const matched = promotionRules.value.find(item => item.memberLevelId === current?.levelId) || promotionRules.value[0]
  selectedLevelId.value = matched?.memberLevelId || current?.levelId || 0
  selectedVenueId.value = 0
  transferAmount.value = ''
}

function selectPromotionLevel(levelId) {
  selectedLevelId.value = levelId
  selectedVenueId.value = 0
  transferAmount.value = ''
}

async function claimVipPromotion() {
  if (!canClaimPromotion.value) return
  submitting.value = true
  error.value = ''
  try {
    await webApi.claimVipPromotion({
      memberLevelId: selectedLevelId.value,
      venueId: selectedVenueId.value,
      transferAmount: String(transferAmount.value),
    })
    notify('申请成功')
    bonusRefreshKey.value += 1
    await loadVip()
  } catch (claimError) {
    error.value = claimError.message || '申请失败，请重试'
  } finally {
    submitting.value = false
  }
}

async function loadGift() {
  const [rule, info] = await Promise.all([
    webApi.vipGiftRule(),
    webApi.vipReceiptInfo().catch(() => ({ receiverName: '', phone: '', address: '' })),
  ])
  giftRule.value = rule
  receipt.value = {
    receiverName: info?.receiverName || '',
    phone: info?.phone || '',
    address: info?.address || '',
  }
}

async function applyGift() {
  if (!canApplyGift.value) return
  submitting.value = true
  error.value = ''
  try {
    await webApi.updateVipReceiptInfo({
      receiverName: receipt.value.receiverName.trim(),
      phone: receipt.value.phone.trim(),
      address: receipt.value.address.trim(),
    })
    await webApi.applyVipGift({ memberLevelId: giftRule.value.memberLevelId })
    notify('豪礼申请已提交')
    await loadGift()
  } catch (applyError) {
    error.value = applyError.message || '申请失败，请重试'
  } finally {
    submitting.value = false
  }
}

async function loadSection() {
  if (!section.value) return
  const requestId = ++loadRequestId
  if (!isLoggedIn.value) {
    loading.value = false
    resetWelfare()
    return
  }
  loading.value = true
  error.value = ''
  resetWelfare()
  try {
    if (section.value === 'points') await loadPoints()
    if (section.value === 'vip') await loadVip()
    if (section.value === 'gift') await loadGift()
  } catch (loadError) {
    if (requestId === loadRequestId) error.value = loadError.message || '加载失败，请重试'
  } finally {
    if (requestId === loadRequestId) loading.value = false
  }
}

watch(() => [section.value, isLoggedIn.value], loadSection, { immediate: true })
</script>

<style scoped>
.promotion-panel { padding: 24px; border-radius: 18px; box-shadow: none; }
.promotion-heading { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.promotion-panel .promotion-heading h2 { margin: 0; font-size: 20px; line-height: 1.4; font-weight: 600; }
.promotion-panel .promotion-heading p { margin: 6px 0 0; font-size: 13px; line-height: 1.6; }
.promotion-refresh { flex-shrink: 0; min-height: 40px; padding: 0 13px; border: 1px solid #d8e9fa; border-radius: 9px; background: #f1f8ff; color: #1887d8; font: inherit; font-size: 13px; cursor: pointer; }
.promotion-levels { display: grid; grid-template-columns: repeat(auto-fit, minmax(60px, 1fr)); gap: 8px; margin-top: 22px; padding-bottom: 22px; border-bottom: 1px solid #edf2f8; }
.promotion-levels button { min-width: 64px; min-height: 42px; padding: 8px 12px; border: 1px solid #dce7f2; border-radius: 8px; background: #f8fbff; color: #647991; font: inherit; font-size: 14px; transition: background .18s, border-color .18s; }
.promotion-levels button.active { border-color: #1887d8; background: #1887d8; color: #fff; }
.promotion-levels button:hover:not(.active):not(:disabled), .promotion-refresh:hover:not(:disabled) { background: #eaf5ff; border-color: #b9dbf9; }
.promotion-panel button:focus-visible, .promotion-application input:focus-visible, .promotion-application select:focus-visible { outline: 2px solid #179af8; outline-offset: 3px; }
.vip-promotion-layout { display: grid; grid-template-columns: minmax(0, 1.4fr) minmax(260px, 1fr); gap: 32px; padding-top: 24px; }
.promotion-details { min-width: 0; }
.promotion-rule-heading { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; }
.promotion-panel h3 { margin: 0; color: var(--ink, #26344b); font-size: 16px; line-height: 1.5; font-weight: 600; }
.promotion-level-note { padding: 3px 7px; border-radius: 5px; background: #edf6ff; color: #287fb9; font-size: 12px; }
.promotion-metrics { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 0 20px; margin: 12px 0 0; text-align: left; }
.promotion-metrics > div { min-width: 0; padding: 16px 0; border-bottom: 1px solid #edf2f8; }
.promotion-metrics dt { color: #75869c; font-size: 12px; line-height: 1.5; }
.promotion-metrics dd { margin: 7px 0 0; color: #1887d8; font-size: 20px; line-height: 1.4; font-weight: 600; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }
.promotion-venues { margin-top: 20px; }
.promotion-venues > span { color: #75869c; font-size: 12px; }
.promotion-venues ul { display: flex; flex-wrap: wrap; gap: 8px; margin: 10px 0 0; padding: 0; list-style: none; }
.promotion-venues li { padding: 5px 9px; border: 1px solid #e1ebf5; border-radius: 6px; color: #536d87; background: #f8fbff; font-size: 13px; overflow-wrap: anywhere; }
.promotion-application { align-content: start; gap: 16px; margin: 0; padding-left: 28px; border-left: 1px solid #edf2f8; }
.promotion-panel .promotion-notice { margin: 0; padding: 10px 12px; border-radius: 7px; background: #f1f5fa; color: #687b91; font-size: 12px; line-height: 1.7; overflow-wrap: anywhere; }
.promotion-application label { font-size: 13px; }
.promotion-application input, .promotion-application select { min-height: 44px; margin-top: 8px; font: inherit; }
.promotion-application input:disabled, .promotion-application select:disabled { color: #8b9bae; background: #f3f6fa; cursor: not-allowed; }
.promotion-application .primary { width: 100%; min-height: 44px; padding: 11px 16px; border-radius: 9px; font-size: 14px; line-height: 1.6; }
.promotion-application .primary:disabled { color: #8998aa; background: #eaf0f6; box-shadow: none; opacity: 1; cursor: not-allowed; }
.promotion-panel .welfare-error { margin: 0; color: #b34e52; font-size: 13px; }
.promotion-empty { padding: 24px 0; text-align: center; }
@media (max-width: 960px) {
  .vip-promotion-layout { grid-template-columns: minmax(0, 1fr); gap: 24px; }
  .promotion-application { padding: 24px 0 0; border-left: 0; border-top: 1px solid #edf2f8; }
}
@media (max-width: 640px) {
  .promotion-panel { padding: 18px; border-radius: 16px; }
  .promotion-panel .promotion-heading h2 { font-size: 18px; }
  .promotion-heading { gap: 10px; align-items: flex-start; }
  .promotion-refresh { min-height: 44px; padding-inline: 10px; font-size: 12px; }
  .promotion-levels { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 7px; margin-top: 18px; padding-bottom: 18px; }
  .promotion-levels button { flex: 1 0 55px; min-width: 55px; min-height: 44px; padding: 8px; font-size: 13px; }
  .vip-promotion-layout { padding-top: 20px; }
  .promotion-metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 16px; }
  .promotion-metrics dd { font-size: 18px; }
}
@media (prefers-reduced-motion: reduce) {
  .promotion-levels button { transition: none; }
}
</style>
